import React from 'react';
import { Tooltip } from '../../shared/_tooltip';
import Button from '../../shared/form/_Button';
import { TextArea } from '../../shared/_form';
import { Field } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import Immutable from 'immutable';

const OpenAppointmentTooltip = ({ onHandleClose, onHandleCloseAppointment, onHandleNotesSubmit, renderAppointmentTime, appointment,  date, loading, id }) => (
  <Tooltip className='calendar__day__appointment-tooltip calendar__day__appointment-tooltip--open'
    header={ date.format('MMMM D, YYYY') }
    id={ id }
    onClose={ onHandleClose }>
    <div>{ renderAppointmentTime() }</div>
    <br />
    <form onSubmit={ onHandleNotesSubmit }>
      <div className='calendar__day__appointment-tooltip__body__row'>
        <div className='calendar__day__appointment-tooltip__body__label'>NOTES:</div>
        <Field className='calendar__day__appointment-tooltip__text-area' component={ TextArea } name={ `notes${appointment.get('id')}` } />
      </div>
      <div className='form__submit form__submit--space-between'>
        <Button className='form__button form__button--purple' loading={ loading } onClick={ onHandleCloseAppointment } type='button'>Close Appt.</Button>
        <Button className='form__button form__button--green' disabled={ loading } type='submit'>Save</Button>
      </div>
    </form>

  </Tooltip>
);

OpenAppointmentTooltip.propTypes = {
  appointment:                  PropTypes.instanceOf(Immutable.Map),
  date:                         PropTypes.instanceOf(moment),
  formValues:                   PropTypes.instanceOf(Immutable.Map),
  loading:                      PropTypes.bool,
  onHandleClose:                PropTypes.func.isRequired,
  onHandleCloseAppointment:     PropTypes.func.isRequired,
  onHandleNotesSubmit:          PropTypes.func.isRequired,
  renderAppointmentTime:        PropTypes.func.isRequired,
  rep:                          PropTypes.instanceOf(Immutable.Map)
};

export default OpenAppointmentTooltip;



// WEBPACK FOOTER //
// ./app/components/managers/calendar/_OpenAppointmentTooltip.jsx